import { render, staticRenderFns } from "./TawktoSettings.vue?vue&type=template&id=e74dd074"
import script from "./TawktoSettings.vue?vue&type=script&lang=js"
export * from "./TawktoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports